import { useMemo } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { buildQueryArraySorters, useInfiniteTaskComments } from '@sib/api';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@sib/api/constants';

export const useTaskCommentsList = (taskId: string) => {
  const payload = {
    page: DEFAULT_PAGE,
    size: DEFAULT_PAGE_SIZE,
    sort: buildQueryArraySorters([
      {
        field: 'createdAt',
        order: 'desc',
      },
    ]),
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    error,
    isLoading,
    isPending,
  } = useInfiniteTaskComments(taskId, payload);

  const [sentryRef] = useInfiniteScroll({
    loading: isFetchingNextPage,
    hasNextPage,
    onLoadMore: () => {
      if (!isFetchingNextPage) fetchNextPage();
    },
    disabled: !!error,
    rootMargin: '0px 0px 200px 0px',
  });

  const comments = useMemo(
    () => data?.pages.flatMap(({ items }) => items) ?? [],
    [data]
  );

  return {
    comments,
    sentryRef,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isPending,
  };
};
